import React from 'react';
import Icon from '@/ui-components/Icon';
import Typography from '@/ui-components/Typography';
import Flag from 'react-flagkit';

import useBem from '@/use/useBem';
import { openUserProfile } from '@/use/useModal';

export type LeaderboardItemProps = {
  id?: number;
  username: string;
  country?: string | null;
  score: number;
  total: number;
  wins: number;
  losses: number;
  rank: number;
};

const LeaderboardItem = (props: LeaderboardItemProps) => {
  const { id, username, score, rank, country } = props;
  const { bem } = useBem('leaderboard');
  const canOpen = id != null && id > 0;

  const handleOpen = () => {
    if (!canOpen) return;
    openUserProfile(id);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLTableRowElement>) => {
    if (!canOpen) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleOpen();
    }
  };

  return (
    <tr
      className={bem('item', { clickable: canOpen })}
      onClick={canOpen ? handleOpen : undefined}
      onKeyDown={canOpen ? handleKeyDown : undefined}
      tabIndex={canOpen ? 0 : undefined}
      role={canOpen ? 'button' : undefined}
      aria-label={canOpen ? `View ${username}'s profile` : undefined}
    >
      <td className={bem('rank')}>
        <Typography variant="s" component="span">
          {rank}
        </Typography>

        {rank === 1 ? (
          <Icon className={bem('crown')} name="crown-gold" />
        ) : null}
        {rank === 2 ? (
          <Icon className={bem('crown')} name="crown-silver" />
        ) : null}
        {rank === 3 ? (
          <Icon className={bem('crown')} name="crown-bronze" />
        ) : null}
      </td>
      <td className={bem('name')}>
        {country ? (
          <span className={bem('flag')}>
            <Flag country={country.toUpperCase()} size={15} />
          </span>
        ) : null}
        <Typography variant="s" component="span">
          {username}
        </Typography>
      </td>
      <td className={bem('score')}>
        <Typography variant="s" component="span">
          {score}
        </Typography>
      </td>
    </tr>
  );
};

export default LeaderboardItem;
